import ApiHttp from '../http';
import {Movie, Movies, Regions} from '../../model';
import {RegionService} from '../../service';
import moment from 'moment';

class MovieService {

    /**
     * Service for interacting with the movies api
     */
    constructor() {
        this.movies = undefined;
        this.sessions = undefined;
        this.filters = undefined;
        this.movieSessions = undefined;
    }

    /**
     * fetch more information about a particular movie
     * Note: due to a requirement for simplicity and the fact that all movies contain all their information already -
     * i'm just filtering the collection of movies for the movie in question.
     * if the requirement arises that movie detail contains other information - this can be fcons to:
     * ****************************
     *  return ApiHttp.get(`/movies/${id}`)
     *          .then(response => new Movie(response.data);
     * *****************************
     * @param id
     * @returns {Promise.<Movie>|*}
     */
    getMovieDetail(id, withRelated = false) {
        return this.getMovies()
            .then((movies)=> {
                var movie = movies.findById(id);
                return withRelated ? {movie, related: movies.related(movie)} : movie;
            });
    }

    getPrerenderedMovieDetails(movies, id, withRelated = false) {
        var movie = movies.findById(id);
        return withRelated ? {movie, related: movies.related(movie)} : movie;
    }

    /**
     * fetch more information about a particular movie
     * Note: due to a requirement for simplicity and the fact that all movies contain all their information already -
     * i'm just filtering the collection of movies for the movie in question.
     * if the requirement arises that movie detail contains other information - this can be changed to:
     * ****************************
     *  return ApiHttp.get(`/movies/${id}`)
     *          .then(response => new Movie(response.data);
     * *****************************
     * @param id
     * @returns {Promise.<Movie>|*}
     */
    findBySessionId(SessionId,CinemaId) {
        return this.getMovies()
            .then((movies)=> {
                var movie = movies.findBySessionId(SessionId,CinemaId);
                return  movie;
            });
    }

    /**
     * fetch more information about a particular movie
     * Note: due to a requirement for simplicity and the fact that all movies contain all their information already -
     * i'm just filtering the collection of movies for the movie in question.
     * if the requirement arises that movie detail contains other information - this can be changed to:
     * ****************************
     *  return ApiHttp.get(`/movies/${id}`)
     *          .then(response => new Movie(response.data);
     * *****************************
     * @param id
     * @returns {Promise.<Movie>|*}
     */
    findByName(Name) {
        return this.getMovies()
            .then((movies)=> {
                var movie = movies.findByName(Name);
                return  movie;
            });
    }
    /**
     * fetch more information about a particular movie
     * Note: due to a requirement for simplicity and the fact that all movies contain all their information already -
     * i'm just filtering the collection of movies for the movie in question.
     * if the requirement arises that movie detail contains other information - this can be changed to:
     * ****************************
     *  return ApiHttp.get(`/movies/${id}`)
     *          .then(response => new Movie(response.data);
     * *****************************
     * @param id
     * @returns {Promise.<Movie>|*}
     */
    findById(Id) {
        return this.getMovies()
            .then((movies)=> {
                var movie = movies.findById(Id);
                return  movie;
            });
    }

    setPreRenderMovies(movies) {
        if(movies && movies != undefined) {
            this.sessions = movies.sessions
            this.movies = new Movies(movies.movies)
        } else {
            this.movies = undefined
        }

        return this.movies
    }

    /**
     *
     * @returns {Promise.<Movies>|*}
     */
    getMovies(noCache=false) {
        return this.movies = this.movies || ApiHttp.get(`/movies${noCache ? '?noCache=' + noCache : ''}`)
                .then(
                    (response) => {
                        this.sessions = response.data.sessions;
                        return new Movies(response.data.movies)
                    },
                    (error)=> {
                        this.movies = undefined;
                        return Promise.reject(error);
                    }
                )


    }

    getSessionsDictionary(noCache=false) {
        return this.movieSessions = this.movieSessions || ApiHttp.get(`/movies${noCache ? '?noCache=' + noCache : ''}`)
                .then(
                    (response) => {
                        return response.data.sessions;
                        // return new Movies(response.data.movies)
                    },
                    (error)=> {
                        this.movieSessions = undefined;
                        return Promise.reject(error);
                    }
                )        
    }

    getSessions(movie_id, cinema_id = null, groupedByCinema = true) {

        return ApiHttp.get(`/movies/sessions/${movie_id}/${cinema_id}/${groupedByCinema}`)

    }


    /**
     * returns featured movies as a promise.
     * @returns {Promise.<TResult>}
     * @deprecated
     */
    getFeaturedMovies() {
        return this.getMovies()
            .then((movies)=>movies.featured());
    }

    /**
     * returns Movies filtered by release as a promise.
     * @returns {Promise.<Movies>}
     */
    getMoviesByRelease() {
        return this.getMovies()
            .then((movies)=>movies.byRelease());
    }


    /**
     * returns all related movies for a given movie id
     * Note: due to a requirement for simplicity and the fact that all movies contain all their information already -
     * i'm just filtering the collection of movies for the movie in question.
     * if the requirement arises that movie detail contains other information - this can be changed to:
     * ****************************
     *  return ApiHttp.get(`/movies/related/${id}`)
     *          .then(response =>  MovieService._processMoviesResponse(response.data.movies));
     * *****************************
     * @param id
     * @returns {Promise.<TResult>|*}
     */
    getRelatedMoviesById(id) {
        return this.getMovies().then((movies)=> {
            var thisMovie = movies.find(id);
            return movies.related(thisMovie)
        })
    }

    /**
     * returns all related movies for a given Movie.
     * @param movie
     * @returns {Promise.<TResult>}
     */
    getRelatedMovies(movie) {
        return this.getMovies().then((movies)=> {
            return movies.related(movie)
        })
    }


    getFilteredMovies(filterObj) {
        // console.log("MovieService.getFilteredMovies hit", filterObj)
        return this.getMovies().then((movies)=> {
            // console.log("Movies.getMovies promise resolved", movies)
            return new Movies(movies.filter(filterObj))
        })

    }

    openingDateDesc(a,b) {
        if(a.opening_date != null && a.opening_date != undefined && b.opening_date != null && b.opening_date != undefined) {
            if (a.opening_date.timestamp < b.opening_date.timestamp)
                return -1;
            // if (a.last_nom > b.last_nom)
            //     return 1;
        }

        return 0;
    }

    moviesByRelease(movies) {
        let data = {
            now_showing: [],
            coming_soon: [],
        }
        for(let m in movies) {
            if(movies[m] != undefined && movies[m] != null) {
                if(movies[m].now_showing === true) {
                    data.now_showing.push(movies[m])
                } else {
                    data.coming_soon.push(movies[m])
                }
            }
        }

        data.coming_soon.sort(this.openingDateDesc)

        return data
    }

    sortfilteredCinemasByDistance(filter_cinemas) {

        return filter_cinemas.sort(function(a, b) {
            if(a.distance && b.distance) {
                if(a.distance != null && b.distance != null) {
                    if(a.distance < b.distance) {
                        return -1
                    }
                }
            }

            return 0
        })
    }

    sortRegionsByDistance(regions) {
        for(let r in regions) {
            if(regions[r].cinemas != undefined && regions[r].cinemas != null && typeof regions[r].cinemas == "object") {
                let region = regions[r].cinemas
                region.sort(function(a,b) {
                    if(a.distance && b.distance) {
                        if(a.distance != null && b.distance != null) {
                            if(a.distance < b.distance) {
                                return -1
                            }
                        }
                    }

                    return 0
                })

                if(region[0].distance && region[0].distance != null && region[0].distance != undefined) {
                    regions[r].distance = region[0].distance
                    regions[r].cinemas = region
                }
            }
        }

        regions.sort(function(a,b) {
            if(a.distance && b.distance) {
                if(a.distance != null && b.distance != null) {
                    if(a.distance < b.distance) {
                        return -1
                    }
                }
            }

            return 0
        })

        return regions
    }

    filterCinemasToRegionModel(filter_cinemas, regions) {
        // console.log("filter_cinemas", filter_cinemas)
        // console.log("regions", regions)
        let filtered = []
        for(let r in regions) {
            if(regions[r] != undefined && regions[r] != null && typeof regions[r] == "object") {
                if(regions[r].cinemas != undefined && regions[r].cinemas != null) {
                    for(let c in regions[r].cinemas) {
                        if(regions[r].cinemas[c] != undefined && regions[r].cinemas[c] != null && typeof regions[r].cinemas[c] == "object") {
                            for(let fc in filter_cinemas) {
                                if(filter_cinemas[fc] != undefined && filter_cinemas[fc] != null && typeof filter_cinemas[fc] == "object") {
                                    if(filter_cinemas[fc].id != undefined && filter_cinemas[fc].id != null) {
                                        if(regions[r].cinemas[c].id != null && regions[r].cinemas[c].id != undefined) {
                                            if(filter_cinemas[fc].id == regions[r].cinemas[c].id) {
                                                filtered.push(regions[r].cinemas[c])
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        // console.log("filtered", filtered)
        return filtered
    }

    filter (criteria) {

        var result = {};
        result.movies = {};
        result.cinemas = [];
        result.genres = {};
        result.types = {};
        result.times = {};

        // console.log("criteria", criteria)

        return this.getMovies().then((movies_data) => {
            return Promise.resolve(RegionService.getRegionsDictionary()).then((regions) => {
                var movies = movies_data.data
                let doNoSessionMatch = false

                if((criteria.title != null && criteria.title) || (criteria.genres && criteria.genres != null)) {
                    if(!criteria.cinema_id && !criteria.types && !criteria.time_range) {
                        doNoSessionMatch = true;
                    }
                } else {
                    if(!criteria.title && !criteria.genres && !criteria.cinema_id && !criteria.types && !criteria.time_range) {
                        doNoSessionMatch = true
                    }
                }

                for(let m in movies) {
                    var movie = movies[m];
                    let doNoSessionMatch = true

                    for(let c in movies[m].cinemas) {
                        if(movies[m].cinemas[c] != undefined && movies[m].cinemas[c] != null) {
                            for(let s in movies[m].cinemas[c]) {
                                let session = null
                                if(movies[m].cinemas[c][s] != undefined && movies[m].cinemas[c][s] != null) {
                                    // session = movies[m].cinemas[c][s]
                                    // console.log(movies[m].cinemas[c][s])
                                    doNoSessionMatch = false
                                }
                            }
                        }
                    }

                    if(!doNoSessionMatch) {
                        for(let c in movies[m].cinemas) {
                            if(movies[m].cinemas[c] != undefined && movies[m].cinemas[c] != null) {
                                for(let s in movies[m].cinemas[c]) {
                                    let session = null
                                    if(movies[m].cinemas[c][s] != undefined && movies[m].cinemas[c][s] != null) {
                                        session = movies[m].cinemas[c][s]
                                        
                                        if (this.isMatch(criteria, session, movie)) {
                                            result.movies[m] = movie;
                                            // console.log("result movie", result.movies[m])
                                            // console.log("result session", session)
                                            if(session != undefined && session != null) {
                                                if(session.cinema_id && session.cinema_id != undefined) {
                                                    result.cinemas[session.cinema_id] = regions[session.cinema_id];
                                                    // console.log("result cinemas", result.cinemas[session.cinema_id])
                                                }

                                                for(let e in session.experiences) {
                                                    if(session.experiences[e] != undefined && session.experiences[e] != null) {
                                                        if(session.experiences[e].name != undefined && session.experiences[e] != null && typeof session.experiences[e].name == "string") {
                                                            result.types[session.experiences[e].name] = session.experiences[e].name;
                                                            // console.log("result experiences", result.types[session.experiences[e].name])
                                                        }
                                                    }
                                                }
                                                
                                                if(session.time_tag != undefined && session.time_tag != null && typeof session.time_tag == "string") {
                                                    result.times[session.time_tag] = session.time_tag;
                                                    // console.log("result times",result.times[session.time_tag])
                                                }
                                            }

                                            for(let g in movie.genres) {
                                                if(movie.genres[g] != undefined && movie.genres[g] != null) {
                                                    if(movie.genres[g].id != undefined && movie.genres[g].id != null && typeof movie.genres[g].id == "string") {
                                                        result.genres[movie.genres[g].id] = movie.genres[g].id;
                                                        // console.log("result genres", movie.genres[g].id, result.genres[movie.genres[g].id])
                                                    }
                                                }
                                            }


                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        if (this.isMatch(criteria, null, movie)) {
                            result.movies[m] = movie;

                            if(movie.genres != undefined && movie.genres != null) {
                                for(let g in movie.genres) {
                                    if(movie.genres[g] != undefined && movie.genres[g] != null) {
                                        if(movie.genres[g].id != undefined && movie.genres[g].id != null && typeof movie.genres[g].id == "string") {
                                            
                                            result.genres[movie.genres[g].id] = movie.genres[g].id;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                // console.log("result",result)
                return result;
            })
        })
    }

    isMatch(criteria, session = null, movie) {
        let session_time_match = false
        if(criteria.time_range) {
            for(let r in criteria.time_range) {
                if(criteria.time_range[r] != undefined && criteria.time_range[r] != null) {
                    if(session != undefined && session != null && typeof session == "object") {
                        if(session.time_tag.includes(criteria.time_range[r])) {
                            session_time_match = true
                        }
                    }
                }
            }
        }

        let session_genre_match = false
        if(criteria.genres != undefined) {
            if(movie.genres != undefined && movie.genres != null) {
                let match_genres = movie.genres.find((g) => {
                    if(g.id != undefined && g.id != null && typeof g.id == "string") {
                        if(g.id in criteria.genres) {
                            return true
                        }
                    }
                    return false
                })
                if(match_genres != undefined && match_genres != null) {
                    session_genre_match = true
                }
            }
        }

        let session_title_match = false
        if(criteria.title && movie != undefined) {
            if(movie.title != undefined && movie.title != null) {
                // console.log(criteria.title)
                var search = new RegExp(criteria.title.replace(/[^\w\s]/gi, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "").replace(' ', '').toLowerCase(), "i")
                // console.log(movie.title)
                var mTitle = movie.title.replace(/[^\w\s]/gi, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "").replace(' ', '').toLowerCase()
                if(search.test(mTitle)) { 
                    session_title_match = true 
                }
            }
        }


        let match_experiences = false
        let match_cinema = false

        if(session != undefined && session != null && typeof session == "object") {

            match_experiences = this.matchExperienceCriteria(session.experiences, criteria.types)
            // if(match_experiences)
            //     console.log(match_experiences, session.experiences, criteria.types)

            if(session.cinema_id == criteria.cinema_id) {
                match_cinema = true
            }
        } else if(session == null || session == undefined) {
            
            if(movie.experiences != null && movie.experiences != undefined) {
                if(movie.experiences.length > 0) {

                    // console.log("match_experiences", match_experiences, movie.experiences, criteria.types)
                    match_experiences = this.matchExperienceCriteria(movie.experiences, criteria.types)
                    // console.log("match_experiences", match_experiences, movie.experiences, criteria.types)
                }
            }
        }

        return  (!criteria.cinema_id || match_cinema) &&
                (!criteria.time_range || session_time_match) &&
                (!criteria.types || match_experiences) &&
                (!criteria.genres || session_genre_match) &&
                (!criteria.title || session_title_match)

    }

    matchExperienceCriteria(experiences, criteria) {


        
        if(criteria && criteria != undefined && criteria != null && experiences != undefined && experiences != null) {

            let match_experiences = false
            // console.log("experiences", experiences)
            match_experiences = experiences.find((e) => {
                // console.log("e.name", e.name)
                if(e.name != undefined && e.name != null && typeof e.name == "string") {
                    if(e.name.trim() in criteria) {
                        // console.log("match e.name", e.name, criteria)
                        return true
                    }
                }
                return false
            })

            if(match_experiences) {
                // console.log("return", true)
                return true
            }

            if(!match_experiences) {
                match_experiences = experiences.find((e) => {
                    if(e in criteria) {
                        // console.log("match e", e, criteria)    
                        return true
                    }

                    return false
                })
                if(match_experiences != undefined && match_experiences != null) {
                    
                    return true
                }
            }

            
            if(match_experiences != undefined && match_experiences != null) {
                // console.log("return", true)
                return true
            }
        }

        // console.log("return", false)
        return false
    }

    generateTimeRanges() {
        return this.getMovies().then((movies_raw) => {
            var movies = movies_raw.data
            var time_tags = []
            for(let m in movies) {
                if(movies[m] != undefined && movies[m] != null) {
                    for(let t in movies[m].time_tags) {
                        time_tags[movies[m].time_tags[t]] = movies[m].time_tags[t]
                    }
                }
            }

            var unique = time_tags;
            var time_ranges = [];

            for(var i = 1; i <= 24; i++) {
                var hour = 0;
                var next_hour = 0;
                if(i < 10) {
                    hour = "0"+i;
                    if(i < 9) {
                        next_hour = "0"+(i+1);
                    } else {
                        next_hour = (i+1);
                    }
                } else {
                    hour = i;
                    if(i == 23) {
                        next_hour = "00";
                    } else if(i == 24) {
                        hour = "00";
                        next_hour = "01";
                    } else {
                        next_hour = (i+1);
                    }
                    
                }

                let partial_time = hour+":";
                var range = hour+":00 - "+next_hour+":00";
                var has_time_slot = false;
                for(let t in unique) {
                    if(unique[t] != null && unique[t] != undefined && typeof unique[t] === 'string') {
                        if(unique[t].includes(partial_time)) {
                            has_time_slot = true;
                        }
                    }
                }

                if(has_time_slot) {
                    time_ranges.push({"range":range, "hour": hour});
                }
            }

            return Promise.resolve(this.generateRangeGroups(time_ranges)).then((groups) => {
                let groupRanges = {name: "Time", items: groups}

                return groupRanges;
            })
        })
    }

    generateRangeGroups(time_ranges) {

        let groups = [
           {
              range: "Between 9:00 and 10:00",
              id: "9am-10am",
              config_ranges: ["09:", "10:"],
              ranges: [],
           },
           {
              range: "Between 11:30 and 12:30",
              id: "11:30am-12:30pm",
              config_ranges: ["11:", "12:"],
              ranges: [],
           },
           {
              range: "Between 14:00 and 15:15",
              id: "2pm-3:15pm",
              config_ranges: ["14:", "15:"],
              ranges: [],
           },
           {
              range: "Between 17:00 and 18:00",
              id: "5pm-6pm",
              config_ranges: ["17:", "18:"],
              ranges: [],
           },
           {
              range: "Between 19:30 and 20:30",
              id: "7:30pm-8:30pm",
              config_ranges: ["19:", "20:"],
              ranges: [],
           },
           {
              range: "Between 22:00 and 22:45",
              id: "10pm-10:45pm",
              config_ranges: ["22:"],
              ranges: [],
           },
        ]

        for(let t in time_ranges) {
            if(time_ranges[t] != undefined && time_ranges[t] != null) {
                for(let g in groups) {
                    if(groups[g] != undefined && groups[g] != null) {
                        for(let cr in groups[g].config_ranges) {
                            if(groups[g].config_ranges[cr] != undefined && groups[g].config_ranges[cr] != null && time_ranges[t].hour != undefined && time_ranges[t].hour != null) {
                                if(groups[g].config_ranges[cr] == (time_ranges[t].hour+":")) {
                                    groups[g].ranges.push(time_ranges[t])
                                }
                            }
                        }
                    }
                }
            }
        }

        return groups
    }

    generateExperienceGroups(experiences) {
        // console.log("experiences", experiences)
        let group_config = [
            {
              name: "2D",
              types: ["2D", "2D DBOX OR 2D", "2D DBOX", "2D Prestige"],
            },
            {
              name: "3D",
              types: ["3D", "3D IMAX", "3D Prestige", "3D DBOX OR 3D", "3D DBOX"],
            },
            {
              name: "IMAX",
              types: ["3D IMAX", "2D IMAX"],
            },
            {
              name: "Prestige",
              types: ["2D Prestige", "3D Prestige"],
            },
            {
              name: "Kids",
              types: ["2D Kids"],
            },
            {
              name: "DBOX",
              types: ["2D DBOX OR 2D", "3D DBOX OR 3D", "2D DBOX", "3D DBOX"],
            },
            {
              name: "Nouveau",
              types: ["Nouveau", "nouveau", "Nouveau 2D"]
            },
            {
              name: "Subs",
              types: ["2D SUBS", "3D SUBS"]
            },
        ];

        let groups = []

        for(let gc in group_config) {
            let group = {name: group_config[gc].name, types: []}
            for(let t in group_config[gc].types) {
                for(let e in experiences) {
                    if(experiences[e] != undefined && experiences[e] != null) {
                        if(experiences[e].name != undefined && experiences[e].name != null && typeof experiences[e].name == "string") {
                            if(group_config[gc].types[t] != undefined && group_config[gc].types[t] != null && typeof group_config[gc].types[t] == "string") {
                                if(experiences[e].name.trim() == group_config[gc].types[t].trim()) {
                                    group.types.push(experiences[e])
                                }
                            }
                        }
                    }
                }
            }

            let exists = false
            for(let g in groups) {
                if(groups[g].name == group.name) {
                    exists = true;
                }
            }

            if(!exists) {
                groups.push(group)
            }
        }

        return groups
    }

    filterExperienceGroups(type_groups, types) {

        let availableGroups = []
        let otherGroups = []

        for(let tg in type_groups) {
            if(type_groups[tg] != undefined && type_groups[tg] != null) {
                for(let tgt in type_groups[tg].types) {
                    if(type_groups[tg].types[tgt] != undefined && type_groups[tg].types[tgt] != null) {
                        if(types[type_groups[tg].types[tgt].name] != undefined && types[type_groups[tg].types[tgt].name] != null) {
                            let exists = false

                            if(availableGroups.length > 0) {
                                for(let ag in availableGroups) {
                                    if(availableGroups[ag] != undefined && availableGroups[ag] != null) {
                                        if(availableGroups[ag].name == type_groups[tg].name) {
                                            exists = true
                                        }
                                    }
                                }
                            }

                            if(!exists) {
                                availableGroups.push(type_groups[tg])
                            }
                        } else {
                            let exists = false
                            if(otherGroups.length > 0) {
                                for(let og in otherGroups) {
                                    if(otherGroups[og] != undefined && otherGroups[og] != null) {
                                        if(otherGroups[og].name == type_groups[tg].name) {
                                            exists = true
                                        }
                                    }
                                }
                            }

                            if(!exists) {
                                otherGroups.push(type_groups[tg])
                            }
                        }
                    }
                }
            }
        }

        let result = {
            other: [],
            available: availableGroups,
        }

        for(let og in otherGroups) {
            let inAvailable = false
            if(otherGroups[og] != undefined && otherGroups[og] != null) {
                for(let ag in availableGroups) {
                    if(availableGroups[ag] != undefined && availableGroups[ag] != null) {
                        if(otherGroups[og].name == availableGroups[ag].name) {
                            inAvailable = true
                        }
                    }
                }
            }

            if(!inAvailable) {
                result.other.push(otherGroups[og])
            }
        }

        return result
    }
}

export default new MovieService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/movie-service.js